import React from 'react';

import Modal from 'components/curo-components/common/Modal';
import Button from 'components/digifi-wrappers/Button';
import { DocumentIcon } from 'static/images';

interface ISuccessDocumentsUploadedModalProps {
  onClose: () => void;
}

const SuccessDocumentsUploadedModal = ({ onClose }: ISuccessDocumentsUploadedModalProps) => {
  return (
    <Modal
      actionElement={
        <Button size="form" kind="secondary" onClick={onClose}>
          Ok, close window
        </Button>
      }
      description="Your documents are currently under review."
      title="Thank you for uploading your documents"
      modalIcon={<DocumentIcon />}
      onClose={onClose}
    />
  );
};

export default SuccessDocumentsUploadedModal;
